module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image0",
    attrs: {
      "id": "ch-5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/24.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-no"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/d5.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('h1', {
    staticClass: "chapter-title-gr"
  }, [_vm._v("Mind Makeover")]), _vm._v(" "), _c('p', {
    staticClass: "line-image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "d-para"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "brwn"
  }, [_vm._v("W")])]), _vm._v("e’ve discussed what’s going on behind the walls of our minds. What’ve you noticed going on behind the scenes of the statements you profess?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As a way to help train your mind to see good things, choose one of the statements below and use it as a breath prayer. Meditate on the statement. Inhale and exhale through the words as they run through your mind. This is an excellent way to allow your heart-head to feel what you’re trying to learn instead of arguing for or against what you’ve been taught.")]), _vm._v(" "), _c('p', {
    staticClass: "cen-para"
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "Image",
      "src": "images/f1.jpg"
    }
  }), _vm._v(" I find rest in the foundation that is Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "cen-para"
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "Image",
      "src": "images/f1.jpg"
    }
  }), _vm._v(" Jesus is the One I trust with my worries.")]), _vm._v(" "), _c('p', {
    staticClass: "cen-para"
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "Image",
      "src": "images/f1.jpg"
    }
  }), _vm._v(" Thank you, Lord—I do not doubt your tender-loving care.")]), _vm._v(" "), _c('p', {
    staticClass: "cen-para"
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "Image",
      "src": "images/f1.jpg"
    }
  }), _vm._v(" You are peace and goodness. Help me feel you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f24dd02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/012_Chapter05.vue
// module id = 90
// module chunks = 0